import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";

import FavoriteIcon from "@mui/icons-material/Favorite";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from "react-redux";

import { addWish } from "../store/slices/userSlice";
import { getProductUrl } from "../utils/productUrl";

function getProductPrice(product) {
  if ("priceStorage" in product) {
    const firstPrice = parseFloat(product.priceStorage[0].price).toLocaleString(
      "en"
    );

    if (product.priceStorage.length > 1) {
      return `од ${firstPrice} ден.`;
    }

    return `${firstPrice} ден.`;
  }

  return `${parseFloat(product.price).toLocaleString("en")} ден.`;
}

function FeaturedCollectionProduct({ product, category }) {
  const [showFav, setShowFav] = useState(false);
  const [show, setShow] = useState(false);
  const [openConfig, setOpenConfig] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedStorage, setSelectedStorage] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const wishlist = useSelector((state) => state.wishlist);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const productLink = getProductUrl(product);
  const isPhone = product.categories[0] === "telefoni";
  const hasVariants = "priceStorage" in product;

  useEffect(() => {
    setSelectedColor(product.color?.[0] || "");
    setSelectedStorage(product.priceStorage?.[0]?.storage || "");
    setSelectedPrice(product.priceStorage?.[0]?.price || product.price || "");
  }, [product]);

  const showAddedPopup = () => {
    setShow(true);
    setTimeout(() => setShow(false), 2000);
  };

  const addItemToCart = (item) => {
    let current = sessionStorage.getItem("cart");
    current = current ? JSON.parse(current) : [];

    const sameConfigIndex = current.findIndex(
      (entry) =>
        entry.id === item.id &&
        (entry.storage || "") === (item.storage || "") &&
        (entry.color || "") === (item.color || "")
    );

    if (sameConfigIndex >= 0) {
      current[sameConfigIndex].quantity += 1;
    } else {
      current.push(item);
    }

    sessionStorage.setItem("cart", JSON.stringify(current));
    showAddedPopup();
  };

  const handleClick = (event) => {
    event.stopPropagation();

    if (isPhone && hasVariants) {
      setOpenConfig(true);
      return;
    }

    const item = {
      id: product._id,
      title: product.title,
      slug: product.slug,
      price: hasVariants ? product.priceStorage[0].price : product.price,
      storage: hasVariants ? product.priceStorage[0].storage : "",
      color: product.color?.[0] || "",
      img: product.img[0],
      categories: product.categories[0],
      quantity: 1,
    };

    addItemToCart(item);
  };

  const handleConfirmConfig = () => {
    const item = {
      id: product._id,
      title: product.title,
      price: selectedPrice,
      storage: selectedStorage,
      color: selectedColor,
      img: product.img[0],
      categories: product.categories[0],
      quantity: 1,
    };

    addItemToCart(item);
    setOpenConfig(false);
  };

  const handleClickFav = (event) => {
    event.stopPropagation();

    let item = {};

    if ("priceStorage" in product) {
      item = {
        id: product._id,
        title: product.title,
        slug: product.slug,
        price: product.priceStorage[0].price,
        storage: product.priceStorage[0].storage,
        color: product.color?.[0] || "",
        img: product.img[0],
        categories: product.categories[0],
        quantity: 1,
      };
    } else {
      item = {
        id: product._id,
        title: product.title,
        slug: product.slug,
        price: product.price,
        color: product.color?.[0] || "",
        img: product.img[0],
        categories: product.categories[0],
        quantity: 1,
      };
    }

    if (!wishlist.some((entry) => entry.id === item.id)) {
      dispatch(addWish(item));
      setShowFav(true);
      setTimeout(() => setShowFav(false), 2000);
    }
  };

  return (
    <>
      <article
        className={`featured__collection__singlep${
          category ? " featured__collection__singlep--category" : ""
        }`}
        onClick={() => navigate(productLink)}
        role="link"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            navigate(productLink);
          }
        }}
      >
        <div className="featured__product__top">
          <span className="featured__product__brand">
            {product.brand || "Buzz Mobile"}
          </span>
          <div className="featured__collection__icons">
            {!category ? (
              <button
                type="button"
                className="featured__action featured__action--icon"
                onClick={handleClick}
                aria-label="Додај во кошничка"
              >
                <AddShoppingCartIcon />
              </button>
            ) : null}
            <button
              type="button"
              className="featured__action featured__action--icon"
              onClick={handleClickFav}
              aria-label="Додај во желби"
            >
              <FavoriteIcon />
            </button>
          </div>
        </div>

        <div className="single__img">
          <div>
            <LazyLoadImage src={product.img[0]} alt={product.title} />
          </div>
        </div>

        <div className="featured__product__content">
          <p className="fp__title">{product.title}</p>
          <div className="single__price">
            <p className="fp__price">{getProductPrice(product)}</p>
          </div>
        </div>

        {show ? (
          <div className="addtocart__popup">
            <Stack sx={{ width: "100%" }} spacing={2}>
              <Alert severity="success">
                <p>
                  {product.title} е додаден во{" "}
                  <Link to="/cart" className="links">
                    кошничката
                  </Link>
                </p>
              </Alert>
            </Stack>
          </div>
        ) : null}

        {showFav ? (
          <div className="addtocart__popup">
            <Stack sx={{ width: "100%" }} spacing={2}>
              <Alert severity="info">
                <p>
                  {product.title} е додаден во{" "}
                  <Link to="/wishlist" className="links">
                    листата на желби
                  </Link>
                </p>
              </Alert>
            </Stack>
          </div>
        ) : null}
      </article>

      <Dialog
        open={openConfig}
        onClose={() => setOpenConfig(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          className: "product-config__dialog",
        }}
      >
        <DialogContent className="product-config__content">
          <button
            type="button"
            className="product-config__close"
            onClick={() => setOpenConfig(false)}
            aria-label="Close"
          >
            <CloseIcon />
          </button>

          <div className="product-config__header">
            <span className="product-config__eyebrow">Спецификации</span>
            <h3>{product.title}</h3>
            <p>Избери боја и меморија пред да го додадеш телефонот во кошничка.</p>
          </div>

          <div className="product-config__panel">
            {product.color?.length ? (
              <div className="product-config__group">
                <p>Боја</p>
                <div className="single__product__swatches">
                  {product.color.map((color, index) => (
                    <button
                      key={index}
                      type="button"
                      value={color}
                      style={{ backgroundColor: color }}
                      onClick={() => setSelectedColor(color)}
                      className={`sp__colors ${
                        color === selectedColor ? "active-color" : ""
                      }`}
                      aria-label={`Color option ${index + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            ) : null}

            {product.priceStorage?.length ? (
              <div className="product-config__group">
                <p>Меморија</p>
                <div className="single__product__storage-list">
                  {product.priceStorage.map((storage, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => {
                        setSelectedStorage(storage.storage);
                        setSelectedPrice(storage.price);
                      }}
                      className={`sp__storage ${
                        storage.storage === selectedStorage ? "active-storage" : ""
                      }`}
                    >
                      {storage.storage}
                    </button>
                  ))}
                </div>
              </div>
            ) : null}
          </div>

          <div className="product-config__footer">
            <div className="product-config__price">
              <span>Цена</span>
              <strong>{parseFloat(selectedPrice || 0).toLocaleString("en")} ден.</strong>
            </div>
            <button
              type="button"
              className="product-config__submit"
              onClick={handleConfirmConfig}
            >
              Додај во кошничка
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default FeaturedCollectionProduct;
